import { render, staticRenderFns } from "./GroupRoom.vue?vue&type=template&id=0cc56e26"
import script from "./GroupRoom.vue?vue&type=script&lang=js"
export * from "./GroupRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports